import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { Buffer } from 'buffer';
import { SiteName } from '../../../shared/components/domainSupport';

/**
 * Component to generate and display edata authorization links
 * These links allow external users to authorize platforms without logging in
 */
const EdataLinkGenerator = ({ platform, accountId }) => {
  const [copied, setCopied] = useState(false);
  const sellerSelect = useSelector(state => state.sellerSelect);
  const siteName = SiteName();

  // Generate edata link
  const generateEdataLink = () => {
    if (!accountId || !platform) return '';

    // Create the data object with account metadata
    const data = {
      accountId: parseInt(accountId, 10),
      accountName: sellerSelect?.label || `Account ${accountId}`,
      accountType: sellerSelect?.type || null,
    };

    // Encode to base64
    const jsonString = JSON.stringify(data);
    const base64 = Buffer.from(jsonString, 'utf-8').toString('base64');
    const encodedEdata = encodeURIComponent(base64);

    // Build full URL
    const baseUrl = window.location.origin;
    return `${baseUrl}/onboarding/${platform}?edata=${encodedEdata}`;
  };

  const edataLink = generateEdataLink();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(edataLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = edataLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!accountId || !edataLink) {
    return null;
  }

  return (
    <div className="form__form-group">
      <p><strong>External Authorization Link (Optional):</strong></p>
      <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '10px' }}>
        Share this link with someone to authorize this platform for <strong>{sellerSelect?.label || `Account ${accountId}`}</strong> in {siteName} without needing to log in.
      </p>
      <div>
        <Input
          type="text"
          value={edataLink}
          readOnly
          onClick={(e) => e.target.select()}
          style={{
            fontSize: '13px',
            height: '38px',
            padding: '6px 12px',
            marginBottom: '10px',
            width: '100%',
          }}
        />
        <Button
          color="primary"
          onClick={handleCopy}
          style={{
            height: '38px',
            minWidth: '100px',
            padding: '6px 16px',
          }}
        >
          {copied ? 'Copied!' : 'Copy Link'}
        </Button>
      </div>
    </div>
  );
};

EdataLinkGenerator.propTypes = {
  platform: PropTypes.string.isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default EdataLinkGenerator;
